var _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefitShadow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 353,
    height: 353,
    viewBox: "0 0 353 353",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 176.051,
    cy: 176.051,
    r: 176.051,
    fill: "url(#paint0_radial_526_1846)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_526_1846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(176.051 176.051) rotate(90) scale(176.051)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C2453"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#121318",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefitShadow);
export default __webpack_public_path__ + "static/media/benefit-shadow.ab3a0874c4ff6697f8a22681e8a48837.svg";
export { ForwardRef as ReactComponent };